import { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateTaskFromWS } from 'app/store/reducers/tasks';
import { createTakeFromWS, updateTakeFromWS } from 'app/store/reducers/takes';
import { addLinkFromWS, updateAssetFromWS } from 'app/store/reducers/assets';
import { createAssetFlagsFromWS, deleteAssetFlagsFromWS } from 'app/store/reducers/reduxAssetFlags';
import { createAssetLinksFromWS, deleteAssetLinksFromWS } from 'app/store/reducers/reduxAssetLinks';
import { createTakeValidationMediasFromWS, deleteTakeValidationMediasFromWS, } from 'app/store/reducers/reduxTakeValidationMedias';
import { createTakeRefMediasFromWS, deleteTakeRefMediasFromWS } from 'app/store/reducers/reduxTakeRefMedias';
import { addFlagFromWS } from 'app/store/reducers/reduxFlags';
import { createDynamicApprovalValueFromWS, deleteDynamicApprovalValueFromWS, updateDynamicApprovalValueFromWS, } from 'app/store/reducers/reduxDynamicApprovalValues';
import { createPostBoardNoteFromWS, deletePostBoardNoteFromWS, updatePostBoardNoteFromWS, } from 'app/store/reducers/reduxPostBoardNotes';
import { addMediaFromWS } from 'app/store/reducers/reduxMedias';
import { WebsocketContext } from './WebsocketProvider';
const useWebsocket = () => {
    const dispatch = useDispatch();
    const { isReady, ws } = useContext(WebsocketContext);
    useEffect(() => {
        if (isReady) {
            ws.addEventListener('message', (event) => {
                const data = JSON.parse(event.data);
                const { event: eventType, data: updatedData, model, timestamp } = data;
                if (eventType === 'message')
                    return;
                switch (eventType) {
                    case 'create':
                        const { flagInst, mediaInst, to_assetInst } = updatedData;
                        switch (model) {
                            case 'AssetFlags':
                                dispatch(addFlagFromWS(flagInst));
                                dispatch(createAssetFlagsFromWS(updatedData));
                                break;
                            case 'AssetLinks':
                                dispatch(addLinkFromWS(to_assetInst));
                                dispatch(createAssetLinksFromWS(updatedData));
                                break;
                            case 'DynamicApprovalValue':
                                dispatch(createDynamicApprovalValueFromWS(updatedData));
                                break;
                            case 'PostBoardNote':
                                dispatch(createPostBoardNoteFromWS(updatedData));
                                break;
                            case 'Take':
                                dispatch(createTakeFromWS(updatedData));
                                break;
                            case 'TakeValidationMedias':
                                dispatch(addMediaFromWS(mediaInst));
                                dispatch(createTakeValidationMediasFromWS(updatedData));
                                break;
                            case 'TakeRefMedias':
                                dispatch(addMediaFromWS(mediaInst));
                                dispatch(createTakeRefMediasFromWS(updatedData));
                                break;
                            default:
                                return;
                        }
                        break;
                    case 'update':
                        switch (model) {
                            case 'Asset':
                                dispatch(updateAssetFromWS(updatedData));
                                break;
                            case 'DynamicApprovalValue':
                                dispatch(updateDynamicApprovalValueFromWS(updatedData));
                                break;
                            case 'PostBoardNote':
                                dispatch(updatePostBoardNoteFromWS(updatedData));
                                break;
                            case 'Task':
                                dispatch(updateTaskFromWS(updatedData));
                                break;
                            case 'Take':
                                dispatch(updateTakeFromWS(updatedData));
                                break;
                            default:
                                return;
                        }
                        break;
                    case 'delete':
                        switch (model) {
                            case 'AssetFlags':
                                dispatch(deleteAssetFlagsFromWS(updatedData));
                                break;
                            case 'AssetLinks':
                                dispatch(deleteAssetLinksFromWS(updatedData));
                                break;
                            case 'DynamicApprovalValue':
                                dispatch(deleteDynamicApprovalValueFromWS(updatedData));
                                break;
                            case 'PostBoardNote':
                                dispatch(deletePostBoardNoteFromWS(updatedData));
                                break;
                            case 'TakeValidationMedias':
                                dispatch(deleteTakeValidationMediasFromWS(updatedData));
                                break;
                            case 'TakeRefMedias':
                                dispatch(deleteTakeRefMediasFromWS(updatedData));
                                break;
                            default:
                                return;
                        }
                        break;
                    default:
                        return;
                }
            });
        }
    }, [isReady]);
};
export default useWebsocket;
